import {API_URL} from "common/const";
import {fetchApiClient} from "common/fetchApiClient";
import {AxiosError} from "axios";
import UnauthorizedError from "api/errors/UnauthorizedError";


const signOut = async (token: string | undefined): Promise<void> => {
    const apiClient = fetchApiClient(token);

    return await apiClient.post<void>(`${API_URL}/auth/sign_out`, {}).then(response => {
        return response.data;
    }).catch((error: AxiosError) => {
        console.log(`Error signing out for Token(${token})`, error);
        if (!!error.response && error.response.status === 403) {
            throw new UnauthorizedError();
        }
        throw error;
    });
}

export default signOut;
